module.exports = __webpack_public_path__ + "img/icon-config.36c8feb7.svg";